import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogMessageComponent } from './dialog-message.component';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { MatIconModule } from '@angular/material/icon';
import { OpenZenDeskModule } from '@fantaz/shared/directives/open-zendesk';

@NgModule({
  imports: [CommonModule, MaterialModule, MatIconModule, OpenZenDeskModule],
  declarations: [DialogMessageComponent],
  exports: [DialogMessageComponent, MaterialModule],
})
export class SharedUiDialogMessageModule {}
